import { AppComponent } from './app.component';
import { AppLayoutModule } from './common/modules/app-layout/app-layout.module';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HomeComponent } from './features/home/home.component';
import { HttpClientModule } from '@angular/common/http';
import { PrimeNGModule } from './common/modules/primeng.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CardComponent } from './common/components/card/card.component';
import { MobileHeaderComponent } from './features/mobile-header/mobile-header.component';
import { AboutUsComponent } from './features/about-us/about-us.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CardComponent,
    MobileHeaderComponent,
    AboutUsComponent
  ],
  imports: [
    AppLayoutModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    PrimeNGModule,
    ReactiveFormsModule
  ],
  providers: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
